export default {
  form: {
    should_save_payment_info: {
      label: 'Save payment info for faster checkout',
    },
  },
};
